import React from 'react';
import { Badge } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

type Props = {
    icon: React.ReactNode;
    alert: string;
};

function AlertBadge({ icon, alert }: Props) {
    if (!alert) {
        return null;
    }

    return (
        <Badge
            leftSection={
                <div className="flex justify-center items-center">
                    {icon || <IconAlertTriangle color="red" size={18} />}
                </div>
            }
            classNames={{
                root: 'px-2 py-[10px]',
            }}
            radius={4}
            color="red"
        >
            {alert}
        </Badge>
    );
}

export default AlertBadge;
